<template>
  <form class="order-create__section">
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--66 custom-col--sm-100 mr-auto">

        <div class="order-create__row custom-row">
          <div class="order-create__col custom-col"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate([
                          'common_Amount',
                        ])"></div>
            <DefaultSelect
                :options="$store.getters.getProformCategory"
                :label="$t('proform_hSCodeCategory.localization_value.value')"
                :otherValue="'proformData'"
                v-bind:class="{'ui-no-valid': HSCode.validation.category}"
                :errorTxt="$t(`${HSCode.validationTranslate.category}.localization_value.value`)"
                :error="HSCode.validation.category"
                :selected="HSCode.data.category"
                :disabled="type === 'edit'"
                @change="changeCategory"
            />
          </div>
          <div class="order-create__col custom-col"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate([
                          'common_Amount',
                        ])"></div>
            <DefaultSelect
                :options="hSNames"
                :label="$t('proform_hSCodeNameEl.localization_value.value')"
                :otherValue="'proformHSCode'"
                v-bind:class="{'ui-no-valid': HSCode.validation.name}"
                :errorTxt="$t(`${HSCode.validationTranslate.name}.localization_value.value`)"
                :error="HSCode.validation.name"
                :selected="HSCode.data.name"
                :disabled="type === 'edit'"
                @change="changeName"
            />
          </div>
        </div>

        <div class="order-create__row custom-row">
          <div class="order-create__col custom-col">

            <div class="order-create__row custom-row mb-4"
                 v-for="(itemUSA, indexUSA) in HSCode.data.HSGroups"
                 :key="indexUSA"
            >
              <div class="custom-col mb-0">
                <div class="order-create__title-horizontal"
                     v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                  <div class="admin-edit" @click="editTranslate([
              'common_DeleteProduct',
            ])"></div>
                  <TitleHorizontal
                      class="mb-2"
                      :value="''"
                      :rightBtn="true"
                      :rightBtnType="'delete'"
                      :rightBtnText="$t('common_delete.localization_value.value')"
                      @rightBtnClick="HSCode.removeGroup(indexUSA)"
                  />
                </div>
              </div>

              <div class="custom-col custom-col--50 custom-col--sm-100">
                <DefaultInput
                    :label="$t('proform_hSCodeCode.localization_value.value') + ' USA'"
                    :type="'text'"
                    v-bind:class="{'ui-no-valid': itemUSA.validation.codeUSA}"
                    :errorTxt="$t(`${itemUSA.validationTranslate.codeUSA}.localization_value.value`)"
                    :error="itemUSA.validation.codeUSA"
                    v-model="itemUSA.data.codeUSA"
                />
              </div>

              <div class="custom-col custom-col--50 custom-col--sm-100">
                <DefaultInput
                    :label="$t('proform_hSCodeCode.localization_value.value') + ' EU'"
                    :type="'text'"
                    v-bind:class="{'ui-no-valid': itemUSA.validation.codeEU}"
                    :errorTxt="$t(`${itemUSA.validationTranslate.codeEU}.localization_value.value`)"
                    :error="itemUSA.validation.codeEU"
                    v-model="itemUSA.data.codeEU"
                />
              </div>

              <div class="custom-col custom-col--50 custom-col--sm-100">
                <DefaultInput
                    :label="$t('fbm_Duty.localization_value.value')"
                    :type="'text'"
                    v-bind:class="{'ui-no-valid': itemUSA.validation.dutyPercent}"
                    :errorTxt="$t(`${itemUSA.validationTranslate.dutyPercent}.localization_value.value`)"
                    :error="itemUSA.validation.dutyPercent"
                    v-model="itemUSA.data.dutyPercent"
                />
              </div>

              <div class="custom-col custom-col--md-100"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <MultiSelect
                    :options="hSMaterials"
                    :label="$t('proform_hSCodeMaterialEl.localization_value.value')"
                    :otherValue="'proformHSCode'"
                    v-bind:class="{'ui-no-valid': itemUSA.validation.material}"
                    :errorTxt="$t(`${itemUSA.validationTranslate.material}.localization_value.value`)"
                    :error="itemUSA.validation.material"
                    :selected="itemUSA.data.material"
                    :searchable="true"
                    @change="(val) => itemUSA.data.material = val"
                />
              </div>
            </div>

            <div class="order-create__product-btn add-product-btn-wrap">
              <div class="order-create__product-btn-i add-product-btn site-link"
                   @click="addGroup"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['common_AddProduct'])"></div>
                +  {{$t('common_AddNew.localization_value.value')}}
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>



  </form>
</template>

<script>
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import MultiSelect from "@/components/UI/selectiones/MultiSelect/MultiSelect";
import {HSCodeItemGroup} from "@/components/modules/HSCodesModule/models/HSCodeItemGroup";
import TitleHorizontal from "@/components/coreComponents/TitleHorizontal/TitleHorizontal";
export default {
  name: "StepA",
  components: {
    TitleHorizontal,
    MultiSelect,
    DefaultInput,
    DefaultSelect
  },

  props: {
    HSCode: Object,
    type: {
      type: String,
      default: 'create'
    }
  },

  data() {
    return {
      optionsTypes: [
        {
          label: 'USA',
          value: 12,
        },
        {
          label: 'EU',
          value: 13,
        },
      ],

      options: [],

      hSCodes: [],
      hSNames: [],
      hSMaterials: [],
    }
  },

  mounted() {
    this.$store.dispatch('fetchProformCategory', '?filter[exclude_system_categories]=1')

    if (this.type === 'edit'){
      // this.HSCode.setHSCodeItem(this.$store.getters.getHSCodesItem)
      // this.getHSCodesFromType(this.HSCode.getCategory(), 1)
      console.log(this.HSCode.getName());
      this.getHSCodesFromType(
          this.HSCode.getCategory(),
          2,
          this.HSCode.getName().proform_value.id
      )
    }
  },

  methods: {

    addGroup() {
      this.HSCode.data.HSGroups.push(new HSCodeItemGroup())
      this.HSCode.data.HSGroups[this.HSCode.data.HSGroups.length-1].data.material = this.hSMaterials
    },

    changeCategory(val) {
      this.hSNames = []
      this.hSMaterials = []
      if(val === '') {
        this.HSCode.setCategory('')
        return
      }
      this.HSCode.setCategory(val)
      this.getHSCodesFromType(val, 1)
    },

    getHSCodesFromType(val, type, nameId = false) {
      console.log(nameId);
      const query = new this.Query();
      let url = '?';
      let myQuery = query
          .for('posts')

      switch (type) {
        case 1:
          //change category
          myQuery.where('ProformAttachmentProformCategoryId', val.id)
          myQuery.where('ProformAttachmentProformTypeId', type)
          myQuery.where('exclude_hs_codes_by_naming', 1)
          break
        case 2://change name
          myQuery.where('ProformAttachmentProformCategoryId', val.id)
          myQuery.where('ProformAttachmentProformTypeId', type)
          myQuery.where('exclude_hs_by_naming_materials', nameId)
          break
      }

      url = url + myQuery.limit(100000).page(1).url().split('?')[1]

      this.$store.dispatch('getHSCodesFromCategoryId', url).then((response) => {
        switch (type) {
          case 1:
            this.hSNames = response
            break
          case 2:
            this.hSMaterials = response
            if(this.type === 'create') {
              // this.HSCode.data.material = response

              this.HSCode.data.USATypeGroup.forEach(i => {
                i.data.material = response
              })

              this.HSCode.data.EUTypeGroup.forEach(i => {
                i.data.material = response
              })
            }
            break
        }
      })
    },

    changeName(val){
      this.hSMaterials = []
      if(val === '') {
        this.HSCode.setName('')
        return
      }
      this.HSCode.setName(val)
      this.getHSCodesFromType(this.HSCode.getCategory(), 2, val["proform_value"].id)
    },

    changeMaterial(val){
      this.HSCode.setMaterial(val)
    },
  },

}
</script>

<style scoped>

</style>